import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

const Parcours = () => {
  function Parcour(props) {
    return (
      <article className="parcours">
        <div>
          <h3>{props.title} </h3>
          <p>{props.desc}</p>
          <p className="parcour-date">{props.date} </p>
        </div>
        <p>{props.paragraphe}</p>
      </article>
    );
  }
  return (
    <section className="parcours-section" id="parcours">
      <h2>Mon parcours</h2>
      <aside className="parcours-container">
        <Parcour
          title="MaelCorp."
          desc="Developer Web"
          date="2024 - 2025"
          paragraphe="Chez MaelCorp., j'occupe un poste de développeur web en alternance. J’interviens sur la conception et le développement de sites web sur mesure, en m’appuyant sur des technologies modernes. Cette expérience m’a permis d’allier rigueur professionnelle, autonomie et sens du travail en équipe."
        />
        {/* <Parcour
          title="Ilec"
          desc="Développement logiciel"
          date="2024 - 2025"
          paragraphe="Actuellement en formation à l’Ilec, je poursuis ma spécialisation dans le développement logiciel. Cette année me permet de renforcer mes compétences en algorithmie, architecture logicielle et gestion de projet, tout en les appliquant concrètement en entreprise."
        /> */}
        <Parcour
          title="Team Y"
          desc="Développement logiciel"
          date="Novembre 2023 - Decembre 2023"
          paragraphe="Au sein de Team Y, société d'ingénierie informatique vendéenne spécialisée dans les solutions logicielles sur mesure pour l'industrie , j'ai approfondi mes compétences en développement logiciel. Intégré à une équipe agile, j'ai participé à la conception et à la réalisation de projets concrets, renforçant ainsi mes aptitudes techniques et ma capacité à collaborer efficacement."
        />
        <Parcour
          title="Estienne D’Orves"
          desc="Développement logiciel"
          date="2023 - 2024"
          paragraphe="Au lycée Estienne d’Orves, j’ai acquis les bases solides du développement informatique, en explorant aussi bien le développement web que logiciel. Ce cursus m’a offert une première immersion dans les langages de programmation et les méthodes de travail en équipe."
        />
        <Parcour
          title="Les Eucalyptus"
          desc="Système Numericque"
          date="2020 - 2023"
          paragraphe="Ce parcours m’a permis de découvrir l’univers du numérique, notamment les systèmes informatiques, les réseaux et la programmation. Une formation polyvalente qui m’a donné envie d’approfondir mes connaissances dans le développement logiciel et web."
        />
      </aside>
    </section>
  );
};

export default Parcours;
